import scraperApi from '../services/scraperApi'
import _ from 'lodash'

const state = {
	deliveryMethods: [
        {
            key: 'bank-transfer',
            name: 'Bank deposit',
            icon: 'mdi-bank-outline',
            methods: [
                'DIRECT_TO_BANK',
                'SWIFT',
                'BANK_DEPOSIT',
                'BANKDEPOSIT',
                'BANK_TRANSFER',
                'Bank/Mobile Money Account',
            ],
        },
        {
            key: 'mobile-money',
            name: 'Mobile money',
            icon: 'mdi-cellphone-iphone',
            methods: [
                'MOBILE_WALLET',
                'MOBILE_MONEY_TRANSFER',
                'MOBILE_MONEY',
                'Bank/Mobile Money Account',
            ],
        },
        {
            key: 'pickup',
            name: 'Cash pick-up',
            icon: 'mdi-cash',
            methods: [
                'CASH_PICK-UP',
                'OFFICE_PICKUP',
                'CASH_PICKUP',
                'OFFICEPICKUP'
            ],
        },
        {
            name: 'Cash delivery',
            icon: 'mdi-cash',
            methods: [
                'HOMEDELIVERY',
            ],
        },
    ],
}

const getters = {
	deliveryMethods: ({ deliveryMethods }) => deliveryMethods,
}

export default {
	namespaced: true,
	state,
	getters,
}
